/**
 * Returns the appropriate account opening path based on the region.
 * - Global: /open-account (user can choose region)
 * - US: /register
 * - UK/EU: https://europe.republic.com/signup
 */
export const getOpenAccountPath = (activeRegionId?: string): string => {
  switch (activeRegionId) {
    case 'us':
      return '/register';
    // these two below have their own pages
    // case 'uk':
    // case 'europe':
    //   return 'https://europe.republic.com/signup';
    default:
      // Global or undefined
      return '/open-account';
  }
};
